/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Injectable, OnDestroy} from '@angular/core';
import 'rxjs/add/operator/map';
import {BehaviorSubject, Observable, Subscription} from "rxjs";
import {AuthService} from "./auth-service";
import {EventService} from "./event-service";
import {FollowingService} from "./following-service";
import {DeviceUtilityService} from "./device-utility-service/device-utility-service";
import {EventFeatures} from "../models/EventFeatures";
import {UserPublicProfile, UserServiceProvider} from "./user-service/user-service";


@Injectable()
export class SessionService implements OnDestroy {

  private _userSub: Subscription;
  private _publicProfileSub: Subscription;
  private _eventFeaturesSub: Subscription;

  private _userId$: BehaviorSubject<string> = new BehaviorSubject(null);
  userId$: Observable<string> = this._userId$.asObservable();

  private _eventFeatures$: BehaviorSubject<EventFeatures> = new BehaviorSubject<EventFeatures>(null);
  private _publicProfile$: BehaviorSubject<UserPublicProfile> = new BehaviorSubject<UserPublicProfile>(null);

  public eventFeatures$: Observable<EventFeatures> = this._eventFeatures$.asObservable();
  public publicProfile$: Observable<UserPublicProfile> = this._publicProfile$.asObservable();

  private _userSession$: BehaviorSubject<UserSession> = new BehaviorSubject<UserSession>(null);
  userSession$: Observable<UserSession> = this._userSession$.asObservable();

  userId: string = null;

  constructor(private auth: AuthService,
              private userService: UserServiceProvider,
              private eventService: EventService,
              private deviceService: DeviceUtilityService,
              private followingService: FollowingService) {
  }

  // region Public Methods

  init() {
    this.auth.init();

    this._userSub = this.auth.userId.subscribe(uid => {
      this._userId$.next(uid);
      this.userId = uid;

      if (uid) {
        console.log('SessionService ' + uid);
        this._loadUser(uid);
        this._loadPurchasedEvents(uid);
        this._loadFollowing(uid);
        this._initDeviceService(uid);
        this._initPublicProfile(uid);
      }
    });

  }

  // endregion


  // region Private Initialization Methods

  private _loadUser(userId: string) {

  }

  private _loadFollowing(userId: string) {
    this.followingService.initForUser(userId);
  }

  private _loadPurchasedEvents(userId: string) {
    this.eventService.loadPurchasedEventsForUser(userId);
  }

  private _initDeviceService(userId: string) {
    console.log('initDeviceService');
    this.deviceService.initForUser(userId);
  }

  private _initPublicProfile(userId: string) {
    this._publicProfileSub = this.userService.watchPublicProfile(userId)
      .subscribe(profile => {
        this._publicProfile$.next(profile);
      });
  }

  // endregion

  // region Lifecycle Events

  ngOnDestroy(): void {
    if (this._userSub) {
      this._userSub.unsubscribe();
    }
    if (this._publicProfileSub) {
      this._publicProfileSub.unsubscribe();
    }
    if (this._eventFeaturesSub) {
      this._eventFeaturesSub.unsubscribe();
    }
  }

  // endregion

  setEvent(eventId: string) {
    this._userSession$.next({
      userId: this.userId,
      eventId: eventId
    });

    this._eventFeaturesSub = this.eventService.watchFeaturesForEvent(eventId)
      .subscribe(features => {
        console.log(features);
        this._eventFeatures$.next(features);
      });
  }
}

export interface UserSession {
  userId: string,
  eventId?: string
}



// WEBPACK FOOTER //
// ./src/providers/session-service.ts